import { createUseStyles } from 'react-jss';
export const usePopoverButtonStyles = createUseStyles(() => ({
    button: {
        border: 'none',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        padding: '0'
    }
}));
